

import React from 'react';
import S1 from "../assets/image/s1.png"
import S2 from "../assets/image/s2.png"
import S3 from "../assets/image/s3.png"
import S4 from "../assets/image/s4.png"
import S5 from "../assets/image/s5.png"
import BG from "../assets/image/gradient_BG.png"
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';



const WhyUs = () => {
   const navigate = useNavigate()
  const topCardRefs = useRef([]);
   const cardRefs = useRef([]);
  const headingRefs = useRef([]);
 const headlineRef = useRef(null);
  const descriptionRef = useRef(null);
  
  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-show");
        }
      });
    },
    { threshold: 0.3 }
  );

   // Observe top cards
    topCardRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

  // Observe loan cards
  cardRefs.current.forEach((el) => {
    if (el) observer.observe(el);
  });

  // Observe headings
  headingRefs.current.forEach((el) => {
    if (el) observer.observe(el);
  });

    if (headlineRef.current) observer.observe(headlineRef.current);
   if (descriptionRef.current) observer.observe(descriptionRef.current);


  return () => observer.disconnect();
}, []);
 

  // Data for top section (2 cards)
  const topFeatures = [
    {
      id: 1,
      title: "Fast Approvals",
      description: "Get funding decisions quickly, no long waits or back-and-forth.",
      icon: S1
    },
    {
      id: 2,
      title: "Flexible Loan Options",
      description: "Choose a loan that fits your exact business need, from working capital to growth funding.",
      icon: S2
    }
  ];

  // Data for bottom section (3 cards)
  const bottomFeatures = [
    {
      id: 3,
      title: "Simple Process",
      description: "Minimal paperwork. Clear steps. Full support from application to disbursal.",
      icon: S3
    },
    {
      id: 4,
      title: "MSME-Focused Experts",
      description: "Work with people who truly understand the needs and challenges of small business owners",
      icon: S4
    },
    {
      id: 5,
      title: "Trusted Lending Partners",
      description: "We connect you to top NBFCs and financial institutions across India, safely and securely.",
      icon: S5
    }
  ];

  // Icon component renderer
  // const renderIcon = (iconType) => {
  //   switch(iconType) {
  //     case "money":
  //       return (
  //         <div className="relative w-48 h-48 md:w-56 md:h-56 mx-auto">
  //           <div className="absolute inset-0 flex items-center justify-center">
  //             <div className="relative">
  //               <div className="absolute -top-8 -right-8 w-16 h-16 bg-emerald-600 rounded-2xl opacity-80 transform rotate-12"></div>
  //               <div className="absolute -bottom-4 -left-6 w-12 h-12 bg-emerald-500 rounded-xl opacity-60 transform -rotate-6"></div>
  //               <div className="relative">
  //                 <div className="absolute -top-4 -left-2 w-32 h-20 bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-xl shadow-xl transform rotate-6"></div>
  //                 <div className="absolute -top-2 left-0 w-32 h-20 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl shadow-xl transform rotate-3"></div>
  //                 <div className="relative w-32 h-20 bg-gradient-to-br from-emerald-400 to-emerald-500 rounded-xl shadow-2xl flex items-center justify-center">
  //                   <div className="text-white text-4xl font-bold">₹</div>
  //                 </div>
  //               </div>
  //               <div className="absolute -left-12 top-1/2 -translate-y-1/2 space-y-1.5">
  //                 <div className="w-8 h-2.5 bg-emerald-600 rounded-full"></div>
  //                 <div className="w-8 h-2.5 bg-emerald-500 rounded-full"></div>
  //                 <div className="w-8 h-2.5 bg-emerald-400 rounded-full"></div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
      
  //     case "checkmark":
  //       return (
  //         <div className="relative w-48 h-48 md:w-56 md:h-56 mx-auto">
  //           <div className="absolute inset-0 flex items-center justify-center">
  //             <div className="relative">
  //               <div className="absolute -top-6 -right-6 w-12 h-12 bg-emerald-500 rounded-full opacity-40"></div>
  //               <div className="absolute -bottom-8 -left-4 w-10 h-10 bg-emerald-400 rounded-full opacity-30"></div>
  //               <div className="absolute -left-16 top-4 w-10 h-10 bg-gradient-to-br from-emerald-400 to-emerald-500 rounded-xl shadow-lg flex items-center justify-center transform rotate-12">
  //                 <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
  //                 </svg>
  //               </div>
  //               <div className="relative w-32 h-32 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-2xl shadow-2xl flex items-center justify-center transform hover:scale-105 transition-transform duration-300">
  //                 <svg className="w-20 h-20 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
  //                 </svg>
  //               </div>
  //               <div className="absolute -top-4 -right-12 w-8 h-8 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-lg shadow-md flex items-center justify-center transform -rotate-12">
  //                 <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
  //                 </svg>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
      
  //     case "gear":
  //       return (
  //         <div className="relative w-40 h-40 md:w-48 md:h-48 mx-auto">
  //           <div className="absolute inset-0 flex items-center justify-center">
  //             <div className="relative">
  //               <div className="absolute -top-6 -right-8 w-12 h-12 bg-emerald-500 rounded-full opacity-30 blur-sm"></div>
  //               <div className="absolute -bottom-4 -left-6 w-10 h-10 bg-emerald-400 rounded-full opacity-40 blur-sm"></div>
  //               <div className="relative w-28 h-28 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full shadow-2xl flex items-center justify-center">
  //                 <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  //                 </svg>
  //               </div>
  //               <div className="absolute -top-2 -right-2 w-12 h-12 bg-gradient-to-br from-emerald-300 to-emerald-500 rounded-full shadow-xl flex items-center justify-center border-4 border-white">
  //                 <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
  //                 </svg>
  //               </div>
  //               <div className="absolute -bottom-4 -left-4 w-10 h-10 bg-gradient-to-br from-emerald-400 to-emerald-500 rounded-full shadow-lg flex items-center justify-center">
  //                 <div className="w-4 h-5 bg-white rounded-full"></div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
      
  //     case "person":
  //       return (
  //         <div className="relative w-40 h-40 md:w-48 md:h-48 mx-auto">
  //           <div className="absolute inset-0 flex items-center justify-center">
  //             <div className="relative">
  //               <div className="absolute -top-8 right-0 w-10 h-10 bg-emerald-600 rounded-xl opacity-50 transform rotate-12"></div>
  //               <div className="relative">
  //                 <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full shadow-xl mx-auto mb-2"></div>
  //                 <div className="w-20 h-24 bg-gradient-to-br from-emerald-400 to-emerald-500 rounded-2xl shadow-xl mx-auto"></div>
  //               </div>
  //               <div className="absolute -left-8 top-8 w-10 h-10 bg-gradient-to-br from-emerald-400 to-emerald-500 rounded-xl shadow-lg flex items-center justify-center transform rotate-12">
  //                 <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
  //                   <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  //                 </svg>
  //               </div>
  //               <div className="absolute -right-6 top-4 w-12 h-12 bg-gradient-to-br from-emerald-300 to-emerald-400 rounded-full shadow-lg flex items-center justify-center">
  //                 <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
  //                   <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z" />
  //                 </svg>
  //               </div>
  //               <div className="absolute -right-2 bottom-4 w-10 h-10 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full shadow-lg flex items-center justify-center border-3 border-white">
  //                 <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
  //                 </svg>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
      
  //     case "shield":
  //       return (
  //         <div className="relative w-40 h-40 md:w-48 md:h-48 mx-auto">
  //           <div className="absolute inset-0 flex items-center justify-center">
  //             <div className="relative">
  //               <div className="absolute inset-0 bg-emerald-400 rounded-full opacity-20 blur-2xl"></div>
  //               <div className="relative w-28 h-32 bg-gradient-to-br from-emerald-400 to-emerald-600 shadow-2xl flex items-center justify-center" style={{clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)'}}>
  //                 <div className="w-24 h-28 bg-gradient-to-br from-emerald-300 to-emerald-500 flex items-center justify-center" style={{clipPath: 'polygon(50% 5%, 95% 27%, 95% 73%, 50% 95%, 5% 73%, 5% 27%)'}}>
  //                   <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  //                   </svg>
  //                 </div>
  //               </div>
  //               <div className="absolute -top-4 -right-4 w-10 h-10 bg-gradient-to-br from-emerald-300 to-emerald-400 rounded-full shadow-lg flex items-center justify-center">
  //                 <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
  //                 </svg>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
      
  //     default:
  //       return null;
  //   }
  // };

  return (
     <>
   <style>{`
         /* 
          ANIMATION CONTROLS:
          - Change 'duration' values to speed up/slow down animations (e.g., 0.6s, 0.8s, 1s)
          - Change 'transitionDelay' in inline styles to control stagger timing
          - Adjust 'translateY' values to control how far elements move (20px, 40px, 60px)
          - Adjust 'threshold' in IntersectionObserver (0.1 to 0.5) to trigger earlier/later
        */

        .card-base {
          opacity: 0;
          transform: translateY(10px); /* Distance elements move from - increase for more dramatic effect */
          transition: opacity 0.1s ease-out, transform 0s ease-out; /* Duration: 0.6s - adjust for speed */
        }

        .card-base.animate-show {
          opacity: 1;
          transform: translateY(0);
        }

        .card-image-container {
          opacity: 0;
          transform: scale(0.9); /* Scale from 0.9 - lower for more zoom effect */
          transition: opacity 0.5s ease-out, transform 0.1s ease-out; /* Duration: 0.5s */
        }

        .card-base.animate-show .card-image-container {
          opacity: 1;
          transform: scale(1);
          transition-delay: 0s; /* Delay before image animates - adjust for timing */
        }

        .card-content-wrapper {
          opacity: 0;
          transform: translateY(2px); /* Distance content moves from */
          transition: opacity 0s ease-out, transform 0s ease-out; /* Duration: 0.5s */
        }

        .card-base.animate-show .card-content-wrapper {
          opacity: 1;
          transform: translateY(0);
          transition-delay: 0s; /* Delay before content animates - adjust for timing */
        }

   

        @keyframes floatIn {
          0% {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          100% {
            opacity: 1;
            transform: translateY(0px) scale(1);
          }
        }

        .word-animate {
          display: inline-block;
          opacity: 0;
          transform: translateY(20px);
        }

        .animate-show .word-animate {
          animation: wordReveal 0.4s ease-out forwards;
        }
           .description-animate {
          opacity: 0;
          transform: translateY(20px);
        }

        .description-animate.animate-show {
          animation: slideUpFade 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s forwards;
        }

        @keyframes wordReveal {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
 <section id="whyus" className="py-20">
        <div className="max-w-[1280px] mx-auto px-5 sm:px-6 md:px-10 lg:px-12 ">
          <div className='  flex flex-col  mx-auto -mb-2 sm:mb-2 lg:mb-2 max-w-[322px] sm:max-w-[402px] md:max-w-[460px] lg:max-w-[582px]'>

              <div  ref={descriptionRef}
                    className=" headline-animate  flex justify-center  items-center  mb-6">
              <div 
                    className="  w-fit h-fit border-[#0BA36C] border-[1.5px] rounded-tl-[21px] rounded-tr-[6px] rounded-bl-[5px] rounded-br-[6px] pt-[4px] pr-[16px] pl-[16px] pb-[5px] ">
                <span className="text-[#0BA36C] text-[16px] font-inter font-semibold">Why Us</span>
              </div>
            </div>
            
                          <h2
  ref={headlineRef}
    className="card-base text-[28px] leading-[36px]  font-poppins  sm:text-[30px]  md:text-[38px] lg:text-[38px] xl:text-[48px] sm:leading-[36px] md:leading-[48px] lg:leading-[48px] xl:leading-[62px] font-medium  -tracking-[4%] text-gray-900 mb-4 text-center">

  {["Why", "Choose"].map((word, i) => (
    <span
      key={i}
      className="word-animate"
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  <br/>

  {["Reap", "Captal?"].map((word, i) => (
    <span
      key={i + 4}
      className="word-animate text-[#0BA36C]"
      style={{ animationDelay: `${(i + 4) * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  
</h2> 
                  <p 
    className=" text-center text-[#404040] text-[17px]  mb-12 max-w-[460px] mx-auto sm:text-[17px] md:text-[17px] lg:text-[17px] ">
                  We Keep It Simple, So You Can Focus on Business         </p>
          
          
          </div > 
     
         <div className=" flex flex-col  max-w-7xl mx-auto">
        {/* Top Section - 2 Cards */}
        <div className="grid grid-cols-1 -mb-2 md:-mb-5 md:grid-cols-[1.5fr_1fr] gap-[24px] md:gap-[24px]">
           
           {/* Big 1 Cards */}
          <div 
ref={(el) => (headingRefs.current[0] = el)}            className=" card-base
              bg-cover bg-center
              rounded-tl-[60px] rounded-tr-[20px] 
              rounded-bl-[20px] rounded-br-[20px]
              border border-black/12 border-[1px] 
              overflow-hidden shadow-lg hover:shadow-xl
              transition-shadow duration-300"
            style={{ backgroundImage: `url(${BG})`, transitionDelay: '10s' }}>
              <div className="">
                <div className=" relative min-w-[384px] w-full h-full  items-center mx-auto">
                  <img src={S1} alt='' className=" w-full h-full min-h-[260.70001220703125px] sm:min-h-[330.70001220703125px]  md:min-h-[160.70001220703125px] lg:min-h-[267.70001220703125px]   object-cover" />

                  {/* Small white gradient bottom → top */}
                  <div class="absolute bottom-0 left-0 w-full h-[20%]
            bg-gradient-to-t from-[#e7fff683] to-[#e1fcf200]">
</div>

                </div>


              </div>
              
              <div  className=" flex flex-col pt-[0px] pb-[24px] px-[16px] md:pt-[11px] pb-[16px] px-[16px] lg:pt-[11px] pb-[24px] px-[32px]   ">
              <h2 className="text-[20.14px] md:text-[26.14px] font-semibold text-black mb-4">
                Fast Approvals
              </h2>
              <p className="text-[#3F3F3F] text-[17px] md:text-[17px] max-w-[360px] leading-relaxed">
                Get funding decisions quickly, no long waits or back-and-forth.
              </p>
              </div>
          </div>

                     {/* Big 2 Cards */}

            <div 
            
                ref={(el) => (topCardRefs.current[0] = el)}
            className="card-base
              bg-cover bg-center
              rounded-tl-[60px] rounded-tr-[20px] 
              rounded-bl-[20px] rounded-br-[20px]
              border border-black/12 border-[1px] 
              overflow-hidden shadow-lg hover:shadow-xl
              transition-shadow duration-300 shadow-lg hover:shadow-xl transition-shadow duration-300"
              style={{ backgroundImage: `url(${BG})`, transitionDelay: '0s'  }} >

              <div className="">
                <div className=" card-image-container relative min-w-[384px] w-full h-full mx-auto">
                  <img src={S2} alt='' className=" w-full h-full min-h-[260.70001220703125px] sm:min-h-[330.70001220703125px]  md:min-h-[80.70001220703125px] md:w-fit md:h-[140.70001220703125px] lg:min-h-[267.70001220703125px]   object-cover" />

                  {/* Small white gradient bottom → top */}
                  <div class="absolute bottom-0 left-0 w-full h-[20%]
            bg-gradient-to-t from-[#e7fff683] to-[#e1fcf200]">
            </div>

                </div>


              </div>
              
              <div  className=" flex flex-col pt-[0px] pb-[24px] px-[16px] md:pt-[11px] pb-[16px] px-[14px] lg:pt-[11px] pb-[24px] px-[32px]   ">
              <h2 className="text-[20px] md:text-[26.14px] font-semibold text-black mb-4">
                Trusted Lending Partners
              </h2>
              <p className="text-[#3F3F3F] text-[17px] md:text-[17px] max-w-[360px] leading-relaxed">
               Choose a loan that fits your exact business need, from working capital to growth funding.
              </p>
              </div>
            </div>
            
         
        </div>

        {/* Bottom Section - 3 Cards */}
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 
                gap-[24px] md:gap-[24px] mt-8 md:mt-12 
                place-items-center md:place-items-start lg:place-items-center">
          {bottomFeatures.map((feature, index) => (
          <div key={feature.id} 
            ref={(el) => (cardRefs.current[feature.id] = el)}
            style={{ animationDelay: `${feature.id * 0.08}s`, backgroundImage: `url(${BG})` }}
            className={` card-base opacity-0
              relative w-fit h-fit md:max-w-[460.70001220703125px] 
              bg-cover bg-center
              rounded-tl-[60px] rounded-tr-[20px] 
              rounded-bl-[20px] rounded-br-[20px]
              border border-black/12 border-[1px] 
              overflow-hidden shadow-lg hover:shadow-xl
              transition-shadow duration-30
              ${index === 2 ? 'md:col-span-2 lg:col-span-1' : ''}
            `}
          >
      
              <div className="">
                <div className="relative w-full h-full  mx-auto">
                  <img src={feature.icon} alt='' className="w-full h-full object-cover" />

                  {/* Small white gradient bottom → top */}
                  <div class="absolute -bottom-2 left-0 w-full h-[20%]
            bg-gradient-to-t from-[#e7fff683] to-[#e1fcf200]">
</div>

                </div>


              </div>
              <div  className=" flex flex-col pt-[0px] pb-[24px] px-[16px] md:pt-[0px] pb-[24px] px-[16px]    ">
              <h2 className=" text-[20.14px] md:text-[26.14px] font-semibold text-black mb-4">
                {feature.title}
              </h2>
              <p className="text-[#3F3F3F] text-[17px] md:text-[17px] leading-relaxed">
                {feature.description}
              </p>
              </div>
            </div>
          ))}
        </div>
      </div>
          <div className="flex justify-center items-center mt-16 gap-[12px]  sm:gap-[14px] lg:gap-[24px] max-w-[1280px] w-full mx-auto">
      <style>{`
              .bg-gradient-radial {
                background: radial-gradient(ellipse at top center, #149D64 0%, #0B6351 10%);
              }

              /* DEFAULT State */
              .button-default {
                box-shadow:
                  /* Outer border glow */
                  0 0 0 0.9px #47ffd48e,

                  

                  /* Inner gradient glow (green blur inside) */
                  inset 0 0 20px rgba(25, 180, 140, 1.0),

                  /* Thin inner border glow */
                  inset 0 0 10px rgba(42, 157, 114, 0.7);
              }

              /* HOVER State */
              .button-default:hover {
                box-shadow:
                   /* Outer border glow */
                  0 0 0 4px #47ffd48e,

                  

                  /* Inner gradient glow (green blur inside) */
                  inset 0 0 0px rgba(0, 0, 0, 0),

                  /* Thin inner border glow */
                  inset 0 0 0px rgba(0, 0, 0, 0);
              }
            `}</style>
             <div className=' h-[1px] w-full bg-[#8DDFBA] gap-'>  </div>
            <button
               ref={(el) => (topCardRefs.current[1] = el)}
            style={{ transitionDelay: '0.30s' }} /* Change delay here */
            className="card-base
                relative
                 
                text-xl font-semibold text-white
                rounded-[18px]
                min-w-[176px] min-h-[56px]
                bg-black
                button-default
                hover:text-[#2a9d72]
                cursor-pointer
                transition-all duration-300
                z-20
                
              "
onClick={() => navigate('/contact')}

             >
              Let's Start
            </button>
            <div className=' h-[1px] w-full bg-[#8DDFBA]'>  </div>

      </div>
    </div>
    
    </section>
    </>
  );
};

export default WhyUs;





